// 1. Sezon - katılım bonusu uygulanmaz (sezon bitti)
export const FIRST_SEASON_ID = 'season-1';

export const shouldApplyParticipationBonus = (seasonId: string): boolean =>
  seasonId !== FIRST_SEASON_ID;

export interface PlayerBadge {
  type: 'team' | 'country' | 'league' | 'style';
  id: string;
}

export interface PlayerBadgesData {
  country?: string;
  league?: string;
  team?: string;
  styles?: string[];
}

export interface Player {
  id: string;
  name: string;
  position: string;
  image?: string; // Oyuncu profil görseli (kadro sayfası için)
  profileImage?: string; // Puan durumu için profil fotoğrafı (yönetici tarafından eklenmiş)
  code: string; // Oyuncu kodu (örn: "#oğuzhan")
  playerCard?: string | { [seasonId: string]: string }; // Oyuncu kartı PNG görseli - eski format (string) veya yeni format (sezon bazlı)
  playerCards: string[] | { [seasonId: string]: string[] }; // Oyuncu kartları - eski format (string[]) veya yeni format (sezon bazlı)
  badges?: PlayerBadgesData; // Rozetler: ülke (sol), lig (orta), takım (sağ), oyuncu tarzları (alt satır)
  stats: {
    [seasonId: string]: SeasonStats;
  };
}

export interface SeasonStats {
  matches: number;
  wins: number;
  draws: number;
  losses: number;
  goals: number;
  assists: number;
  ownGoals: number; // Kendi kalesine gol
  points: number;
  blackCards: number; // Siyah Kart
  mvdpCards: number; // MVDP
}

export interface Match {
  id: string;
  date: string;
  seasonId: string;
  blackTeam: string[]; // Oyuncu ID'leri
  whiteTeam: string[]; // Oyuncu ID'leri
  blackScore: number;
  whiteScore: number;
  events: MatchEvent[];
  blackCard?: string; // Oyuncu ID
  mvdp?: string; // Oyuncu ID
  blackCardImage?: string; // Siyah kart görseli
  mvdpImage?: string; // MVDP kart görseli
  matchImage?: string; // Maç kadroları görseli (dikey)
}

export interface MatchEvent {
  id: string;
  minute: number;
  team: 'black' | 'white';
  scorerId?: string; // Opsiyonel - misafir oyuncu için undefined olabilir
  assistId?: string; // Opsiyonel - misafir oyuncu için undefined olabilir
  guestScorerName?: string; // Misafir oyuncu gol atan ise ismi
  guestAssistName?: string; // Misafir oyuncu asist yapan ise ismi
  ownGoal: boolean;
}

export interface Season {
  id: string;
  name: string;
  isActive: boolean;
}

export interface AdminSettings {
  homePageImage?: string;
  fieldImage?: string; // Kadro sayfası için saha görseli
  matchdayImage?: string; // Matchday splash screen görseli (aktif)
  matchdayImages?: Array<{ id: string; url: string; date: string }>; // Geçmiş matchday görselleri
  faviconUrl?: string; // Tarayıcı logosu (favicon)
  links?: {
    location?: { name: string; url: string; icon?: string }; // Konum linki (Google Maps)
    googleDrive?: { name: string; url: string; icon?: string }; // Google Drive linki
    instagram?: { name: string; url: string; icon?: string }; // Instagram linki
    whatsapp?: { name: string; url: string; icon?: string }; // WhatsApp grup linki
    other?: Array<{ id: string; name: string; url: string; icon?: string }>; // Diğer linkler
  };
}


